import type { Router } from 'vue-router'
import { isAxiosError } from 'axios'
import { useAuthStore } from '@/stores/auth'

export function setupGuards(router: Router) {
    router.beforeEach(async (to, _from, next) => {
        const authStore = useAuthStore()

        if (to.meta.requiresAuth && !authStore.isAuthenticated) {
            // isAuthenticated is false when user.value is null, which can happen if
            // localStorage 'user' was cleared while the httpOnly session cookie is still valid
            // (e.g. incognito reload, Safari ITP, manual clear). Probe /me once before
            // redirecting so a valid cookie session isn't thrown away unnecessarily.
            try {
                await authStore.fetchUser()
            } catch (error: unknown) {
                // 401 from /me means the cookie is genuinely expired — redirect to login.
                // Any other error (network, 5xx) is treated as a transient failure;
                // we let the route proceed and let the component handle auth errors.
                if (isAxiosError(error) && [401, 403].includes(error.response?.status ?? 0)) {
                    next({ path: '/login', query: { redirect: to.fullPath } })
                    return
                }

                next()
                return
            }

            // fetchUser() succeeded — session is valid, allow navigation.
            next()
            return
        }

        next()
    })
}
